import type { UsersSearchRequestDto } from '../types/search-request.dto';
import type { UsersSearchRequestModel } from '../types/search-request.model';

export const toUserSearchRequestDto = (model: UsersSearchRequestModel): UsersSearchRequestDto => {
	return {
		page_size: model.pageSize ?? 100,
		organization_ids: model.organizationIds,
		organization_name: model.organizationName,
		organization_cities: model.organizationCities,
		organization_countries: model.organizationCountries,
		start_time: model.startTime,
		end_time: model.endTime,
		name: model.name,
		continuation_token: model.continuationToken,
	};
};
